import React from 'react';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import SettingsContainer from '@/dashboard/components/SettingsContainer';
import PageHeader from '@dashboard/components/PageHeader';
import Link from '@/dashboard/components/Link';

const SettingsCheckInStaff = () => {
  const { seller } = useAuth();
  const { updateSeller } = useSellerQueries();

  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Check-in staff"
        description={
          <span>
            Manage check-in staff settings.{' '}
            <Link href="/settings/check-in-staff" target="_blank">
              Learn more
            </Link>
          </span>
        }
      />

      <div className="mb-32">
        <SettingsContainer size="lg">
          <Form
            enableReinitialize
            initialValues={{
              eventStaffSettings: {
                allowNameChanges: seller.eventStaffSettings?.allowNameChanges !== false,
              },
            }}
            fields={[
              {
                name: 'eventStaffSettings.allowNameChanges',
                required: false,
                type: 'checkbox',
                label: 'Allow display name changes in the ticket scanner',
              },
            ]}
            onSubmit={async values => {
              try {
                const { data } = await updateSeller(values);
                return { data };
              } catch (error) {
                return { error };
              }
            }}
          />
        </SettingsContainer>
      </div>
    </div>
  );
};

export default SettingsCheckInStaff;
